// extracted by mini-css-extract-plugin
module.exports = {"aboutUsBlock":"Block_aboutUsBlock__1apM5","center":"Block_center__UMFsC"};